<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :items-per-page="25"
      density="compact"
      :no-data-text="loading ? 'Loading...' : 'No data available.'"
    >
      <template #item.organization_name="{ item }">
        <template v-if="item.organization_name">
          <router-link v-if="item.perm_id_organization_id" :to="'/global/organization/' + item.perm_id_organization_id">
            {{ item.organization_name }}
          </router-link>
          <span v-else>{{ item.organization_name }}</span>
        </template>
        <span v-else class="text-grey font-italic">
          <v-icon size="x-small" class="mr-1">mdi-lock</v-icon>Standard subscription required
        </span>
      </template>
      <template #item.total_portfolio_value="{ item }">
        {{ human_number(item.total_market_value) }}
      </template>
      <template #item.total_change_value="{ item }">
        <span :class="item.total_change_value > 0 ? 'text-green' : item.total_change_value < 0 ? 'text-red' : ''">
          {{ item.total_change_value ? human_number(item.total_change_value) : '' }}
        </span>
      </template>
    </v-data-table>
    <v-alert v-if="!isSubscriber && items.length > 0" type="info" variant="tonal" class="mt-3">
      Showing 2 of {{ items.length }} results.
      <a href="/pricing" target="_blank">Subscribe</a> to view all top funds data.
    </v-alert>
    <small>Source: Refinitiv</small>
  </div>
</template>

<script>
import api from '@/store/api'
import { useAppStore, useUserStore } from '@/store'
import FormattersMixin from '@/mixins/formatters'

export default {
  mixins: [FormattersMixin],

  props: {
    ownerCountry: { type: String, required: true }
  },

  data() {
    return {
      loading: false,
      items: [],
      headers: [
        { title: 'Fund Name', key: 'organization_name' },
        { title: 'City', key: 'city' },
        { title: 'Investor Type', key: 'investor_type' },
        { title: 'Total Market Value', key: 'total_portfolio_value' },
        { title: '# Holdings', key: 'total_holdings' },
        { title: 'Net Change in Value', key: 'total_change_value' }
      ]
    }
  },

  computed: {
    isSubscriber() {
      const store = useUserStore()
      return store.isSubscriber || store.isProSubscriber || store.isEnterpriseSubscriber
    }
  },

  watch: {
    ownerCountry() { this.fetchData() }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      api.get('global_top_funds_by_country', { params: { owner_country: this.ownerCountry } })
        .then(response => { this.items = response.data })
        .catch(error => {
          useAppStore().showNotification({ type: 'error', text: (error.response?.data) || error.message })
        })
        .finally(() => { this.loading = false })
    }
  }
}
</script>
